'use client';

import { useCallback } from 'react';
import { useTour } from '../hooks/useTour';
import { useCompleteTourWithTracking } from '../hooks/useCompleteTourWithTracking';
import { WhySmsModal } from './WhySmsModal';

/**
 * WhySmsTourOverlay - Renders the "Why SMS?" data-driven sales walkthrough.
 *
 * Entirely modal-based — no navigation or element highlighting needed.
 */
export function WhySmsTourOverlay() {
  const { isActive, activeTourId, currentStep } = useTour();
  const { completeTourWithTracking } = useCompleteTourWithTracking();

  const isWhySmsTour = activeTourId === 'why-sms';

  const handleFinish = useCallback(() => {
    completeTourWithTracking('why-sms');
  }, [completeTourWithTracking]);

  if (!isWhySmsTour || !isActive || !currentStep) return null;

  return <WhySmsModal onFinish={handleFinish} />;
}
